module.exports = __webpack_public_path__ + "img/组底部3.715cd3c0.png";